<div class="modal-body width-800">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">
      {{getRessource('Update')}}
    </h5>
    <div class="content">
      <div class="typo-normal">
        {{enumSvc.getFieldCaption("Ablaufplan", "apiBezeichnung")}}
        : {{uiModel.apiBezeichnung}}
      </div>
      <exg-select [(ngModel)]="uiModel.apiSequence"
                  disabled="{{disableCondition}}"
                  [list]="data.worklistData" type="text"
                  name="apiSequence"
                  listdisplay="apiBezeichnung"
                  *ngIf="excSecurityService.isFeatured('SCHEDULEMGMT')"
                  [caption]="getRessource('caption.apiSequence')"></exg-select>
      <div class="grid cols-3"
           *ngIf="excSecurityService.isFeatured('SCHEDULEMGMT')">
        <exg-checkbox class="md-check-reverse typo-small"
                      [(ngModel)]="uiModel.apiFreigabe"
                      [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiFreigabe')"
                      disabled="{{disableCondition}}"
                      type="switch"></exg-checkbox>
        <exg-checkbox class="md-check-reverse typo-small" [(ngModel)]="uiModel.apiPruefen"
                      [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiPruefen')"
                      disabled="{{disableCondition}}"
                      type="switch"></exg-checkbox>
        <exg-checkbox class="md-check-reverse typo-small" [(ngModel)]="uiModel.apiMonitoring"
                      [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiMonitoring')"
                      disabled="{{disableCondition}}"
                      type="switch"></exg-checkbox>
      </div>
      <form #modalReceipt="ngForm" class="modal-form">
        <div class="grid cols-3">
          <exg-input [(ngModel)]="uiModel.apiSollDatum" [step]="60"
                     [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiSollDatum')"
                     disabled="{{disableCondition}}" name="apiSollDatum"
                     type="datetime-local" [isEpoch]="true">
          </exg-input>
          <div class="spawn">
            <exg-input [ngModel]="uiModelDates.apiPlanDatumDate"
                       (ngModelChange)="combineDateTime('apiPlanDatum', $event, uiModelDates.apiPlanDatumTime)"
                       [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiPlanDatum')"
                       [disabled]="disableCondition.toString()" name="apiPlanDatumDate"
                       type="date">
            </exg-input>
            <exg-input [ngModel]="uiModelDates.apiPlanDatumTime" [step]="60"
                       (ngModelChange)="combineDateTime('apiPlanDatum', uiModelDates.apiPlanDatumDate, $event)"
                       [caption]="''"
                       [disabled]="disableCondition.toString()" name="apiPlanDatumTime"
                       type="time">
            </exg-input>
          </div>
          <div class="spawn">
            <exg-input [ngModel]="uiModelDates.apiIstDatumDate"
                       (ngModelChange)="combineDateTime('apiIstDatum', $event, uiModelDates.apiIstDatumTime)"
                       [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiIstDatum')"
                       [disabled]="disableCondition.toString()" name="apiIstDatumDatum"
                       type="date">
            </exg-input>
            <exg-input [ngModel]="uiModelDates.apiIstDatumTime" [step]="60"
                       (ngModelChange)="combineDateTime('apiIstDatum', uiModelDates.apiIstDatumDate, $event)"
                       [caption]="''"
                       [disabled]="disableCondition.toString()" name="apiIstDatumTime"
                       type="time">
            </exg-input>
          </div>
        </div>
        <div class="grid cols-3">
          <ng-container *ngIf="excSecurityService.isFeatured('SCHEDULEMGMT')">
            <exg-input [(ngModel)]="uiModel.apiSollDatumLCT"
                       disabled="{{uiModel.apiSollDatum === uiModelClone.apiSollDatum}}"
                       [required]="isRequired()"
                       [hintText]="isRequired() ? '* ' + getRessource('FailCommentary') : ''"
                       [caption]="getRessource('caption.apiSollDatumLCT')"
                       name="apiSollDatumLCT" type="text">
            </exg-input>
          </ng-container>
        </div>
        <div class="grid">
          <div style="margin: 0 0.75rem 0 0.75rem; font-size:smaller" *ngIf="uiModel.apiAblaufplanKategorie_enmIdent">
              <div *ngIf="getRessource('Category.' + uiModel.apiAblaufplanKategorie_enmIdent +'.InfoText') !== 'ModalTaskWorklistComponent.Category.' + uiModel.apiAblaufplanKategorie_enmIdent + '.InfoText'">{{getRessource("Category." + uiModel.apiAblaufplanKategorie_enmIdent +".InfoText")}}</div>
              <div *ngIf="getRessource('Category.' + uiModel.apiAblaufplanKategorie_enmIdent +'.WarningText') !== 'ModalTaskWorklistComponent.Category.' + uiModel.apiAblaufplanKategorie_enmIdent + '.WarningText'" style="color:red; font-weight: bold">{{getRessource("Category." + uiModel.apiAblaufplanKategorie_enmIdent +".WarningText")}}</div>
          </div>
        </div>
        <exg-textarea [(ngModel)]="uiModel.apiKommentar"
                      [caption]="enumSvc.getFieldCaption('Ablaufplan', 'apiKommentar')"
                      disabled="{{disableCondition}}" type="text" #nodeText name="apiKommentar">
        </exg-textarea>
      </form>
    </div>
    <div class="spawn-modal-actions">
      <button class="md-btn" (click)="clickedRelease()"
              *ngIf="excSecurityService.isFeatured('SCHEDULEAPPROVE')">
        Freigeben
      </button>
      <button class="md-btn" *ngIf="uiModel.apiCustom"
              [class.disabled]="!excSecurityService.isFeatured('SCHEDULEDELETE')"
              (click)="clickedDelete()">
        {{getGlobal('Delete')}}
      </button>
      <button class="md-btn"
              [disabled]="disableCondition"
              [class.disabled]="!appSrv.helperObj.changed(uiModel, uiModelClone) || isRequired()"
              (click)="clickedSave()">
        {{getGlobal('Save')}}
      </button>
      <button class="md-btn" (click)="clickedCancel()">
        {{getGlobal('Cancel')}}
      </button>
    </div>
  </div>
</div>
